import { Component } from '@angular/core';
import { CommonInfoService } from '../cart-process/common-info.service';

type Step = {
  text: string;
  classes: { [property: string]: boolean };
};

@Component({
  selector: 'header-component',
  templateUrl: './header.component.html'
})
export class HeaderComponent {
  public currentStep: number;
  public portalUrl: string;
  public steps: Step[] = [
    {
      text: 'Twój koszyk',
      classes: {active: false, checked: false}
    },
    {
      text: 'Dane i zgody',
      classes: {active: false, checked: false}
    },
    {
      text: 'Dostawa i płatność',
      classes: {active: false, checked: false}
    },
    {
      text: 'Podsumowanie',
      classes: {active: false, checked: false}
    },
  ];

  constructor(public commonInfo: CommonInfoService) {
    this.currentStep = commonInfo.pageStep;
    this.portalUrl = commonInfo.portalUrl;

    this.setActive();
  }

  private setActive(): void {
    this.steps[this.currentStep - 1].classes.active = true;

    this.steps.forEach((item: Step, index: number): void => {
      if (index < this.currentStep - 1) {
        item.classes.active = true;
        item.classes.checked = true;
      }
    });
  }

  public getPortalUrl(): string {
    return this.portalUrl ? this.portalUrl : this.commonInfo.isVirginBrand ? 'https://virginmobile.pl/' : 'https://www.play.pl/';
  }
}
